import React, { useState } from 'react';
import './Productspage.css';
import '../scrollReveal.css';
import useScrollReveal from '../hooks/useScrollReveal';

import gallery1 from './works/gallery1.jpg';
import gallery2 from './works/gallery2.jpg';
import gallery3 from './works/gallery3.jpg';
import gallery4 from './works/gallery4.jpg';
import gallery5 from './works/gallery5.jpg';
import gallery6 from './works/gallery6.jpg';
import gallery7 from './works/gallery7.jpg';
import gallery8 from './works/gallery8.jpg';
import gallery9 from './works/gallery9.jpg';
import gallery10 from './works/gallery10.jpg';

const categories = ['All', 'Aero & Body', 'Carbon Fiber', 'Interior', 'Custom Builds'];

const products = [
  { img: gallery1, title: 'Front Splitter Kit', category: 'Aero & Body', desc: 'Custom front splitter and canard set engineered for a Lamborghini Huracán. Printed in high-strength nylon, finished in flat black.' },
  { img: gallery2, title: 'Carbon Fiber Diffuser', category: 'Carbon Fiber', desc: 'Rear diffuser with integrated fin elements. Designed in Fusion 360 to match OEM mounting points exactly.' },
  { img: gallery3, title: 'Custom Intake Plenum', category: 'Custom Builds', desc: 'High-temp resistant intake plenum printed in PA12-CF for a turbocharged V8 application. Optimized airflow geometry.' },
  { img: gallery4, title: 'Side Skirt Extension', category: 'Aero & Body', desc: 'Widebody side skirt extension set replicated from a customer scan — flawless line continuity with the OEM body.' },
  { img: gallery5, title: 'Dashboard Trim Panel', category: 'Interior', desc: 'Full carbon fiber dashboard accent panel, custom modeled to replace a Ferrari 458 OEM piece.' },
  { img: gallery6, title: 'Rear Wing Assembly', category: 'Aero & Body', desc: 'Adjustable swan-neck rear wing designed for downforce and visual impact. One-off commission for a track build.' },
  { img: gallery7, title: 'Carbon Center Console', category: 'Interior', desc: 'Bespoke carbon fiber center console with integrated cup holders and control cluster, designed to match an existing interior.' },
  { img: gallery8, title: 'Body Kit Prototype', category: 'Custom Builds', desc: 'Full-body kit prototype for a McLaren 720S. Multiple revision rounds, final version approved for production.' },
  { img: gallery9, title: 'Brake Duct Housing', category: 'Custom Builds', desc: 'Pre-production engineering sample for aftermarket brake duct kit — printed in SLS nylon for heat and structural testing.' },
  { img: gallery10, title: 'Vented Hood Insert', category: 'Aero & Body', desc: 'Custom vented hood insert for a Porsche 911 GT3 — designed from scratch to match the existing hood profile.' },
];

const Productspage = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightbox, setLightbox] = useState(null);
  const heroRef = useScrollReveal();
  const galleryRef = useScrollReveal();

  const filtered = activeCategory === 'All' ? products : products.filter(p => p.category === activeCategory);

  return (
    <div className="products-page">
      <section className="products-hero" ref={heroRef}>
        <div className="products-hero-bg" />
        <div className="products-hero-grid" />
        <div className="products-hero-corner tl" />
        <div className="products-hero-corner tr" />
        <div className="products-hero-corner bl" />
        <div className="products-hero-corner br" />
        <div className="products-hero-content">
          <div className="products-eyebrow" data-reveal="fade-down">Our Work</div>
          <h1 data-reveal="fade-up" data-delay="150">Portfolio</h1>
          <p data-reveal="fade-up" data-delay="300">Custom aero, body work, and carbon fiber components built for the world's finest cars.</p>
        </div>
      </section>

      <section className="products-gallery-section" ref={galleryRef}>
        <div className="products-gallery-container">
          <div className="products-filter-bar" data-reveal="fade-down" data-delay="100">
            {categories.map((cat) => (
              <button key={cat} className={`filter-btn ${activeCategory === cat ? 'active' : ''}`} onClick={() => setActiveCategory(cat)}>
                {cat}
              </button>
            ))}
          </div>

          <div className="products-grid">
            {filtered.map((item, i) => (
              <div key={i} className="product-card" data-reveal="fade-up" data-delay={String(100 + (i % 3) * 100)} onClick={() => setLightbox(item)}>
                <div className="product-img-wrap">
                  <img src={item.img} alt={item.title} loading="lazy" />
                  <div className="product-img-overlay">
                    <span className="product-view-label">View Details</span>
                  </div>
                </div>
                <div className="product-info">
                  <span className="product-category">{item.category}</span>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {lightbox && (
        <div className="lightbox-overlay" onClick={() => setLightbox(null)}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setLightbox(null)}>✕</button>
            <img src={lightbox.img} alt={lightbox.title} />
            <div className="lightbox-info">
              <span className="product-category">{lightbox.category}</span>
              <h2>{lightbox.title}</h2>
              <p>{lightbox.desc}</p>
            </div>
          </div>
        </div>
      )}

      <footer className="products-footer">
        &copy; {new Date().getFullYear()} KING3DMFG — All Rights Reserved
      </footer>
    </div>
  );
};

export default Productspage;
